import { notyf } from '@modules';
import { debugLog } from '@utils';

class WithdrawalForm extends HTMLElement {
  connectedCallback() {
    this.sectionId = this.dataset.sectionId;
    this.form = this.querySelector('form');
    this.messageEl = this.querySelector('[data-message]');
    this.submitButton = this.form?.querySelector('button[type="submit"]');

    this.translations = (window.withdrawal_translations || {})[this.sectionId] || {};

    this.form?.addEventListener('submit', (event) => this.#handleSubmit(event));
  }

  #showMessage(text, isError) {
    if (!this.messageEl) return;
    this.messageEl.textContent = text;
    this.messageEl.hidden = false;
    this.messageEl.classList.toggle('text-danger', Boolean(isError));
  }

  #toggleLoading(isLoading) {
    if (!this.submitButton) return;
    this.submitButton.disabled = isLoading;
    this.submitButton.classList.toggle('loading', isLoading);
    const inputs = this.form.querySelectorAll('input:not([type="hidden"]), textarea');
    for (const input of inputs) input.disabled = isLoading;
  }

  #getEndpoint() {
    const env = this.dataset.env || 'production';
    const envSlug = env === 'production' ? '' : `--${env}`;
    return `https://tcg-emarsys${envSlug}.gadget.app/withdrawal`;
  }

  #buildPayload() {
    const data = new FormData(this.form);
    return {
      orderNumber: (data.get('order_number') || '').toString().trim(),
      name: (data.get('name') || '').toString().trim(),
      email: (data.get('email') || '').toString().trim(),
      reason: (data.get('reason') || '').toString().trim(),
      shopId: (data.get('shop_id') || '').toString().trim(),
    };
  }

  async #handleSubmit(event) {
    event.preventDefault();

    const payload = this.#buildPayload();
    if (!payload.orderNumber || !payload.name || !payload.email) {
      this.#showMessage(this.translations.missing, true);
      return;
    }

    this.#toggleLoading(true);

    try {
      const response = await fetch(this.#getEndpoint(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      this.form.hidden = true;
      this.#showMessage(this.translations.success, false);
      notyf.success(this.translations.success);
    } catch (error) {
      debugLog('Withdrawal submission failed:', error);
      this.#toggleLoading(false);
      this.#showMessage(this.translations.error, true);
      notyf.error(this.translations.error);
    }
  }
}

customElements.define('withdrawal-form', WithdrawalForm);
